module.exports = __webpack_public_path__ + "static/other/city_builder.0533eff9.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/city_builder.json
// module id = 2650
// module chunks = 0